import 'css-chunksrc/client/common/projectSection/project/managerList/resource/styles.scss';export default {
  "resource": "_resource_1rfpt_1",
  "icon": "_icon_1rfpt_6",
  "removeTagIconContainer": "_removeTagIconContainer_1rfpt_14"
};